import { render, staticRenderFns } from "./modal-package.vue?vue&type=template&id=b197948c&scoped=true&"
import script from "./modal-package.vue?vue&type=script&lang=js&"
export * from "./modal-package.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b197948c",
  null
  
)

export default component.exports